import { Badge } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import api from "../../../utils/api";
import { css } from "../../../../styled-system/css";

export const REPORT_STATUS_COLOR = {
  completed: { backgroundColor: "#d0fceb", color: "#053f28" },
  error: { backgroundColor: "#f8d7da", color: "#842029" },
  pending: { backgroundColor: "#fff3cd", color: "#664d03" },
};

export const AGENT_STATUS_COLOR = {
  ready: { backgroundColor: "#d0fceb", color: "#053f28", label: "Ready" },
  generating: { backgroundColor: "#fff3cd", color: "#664d03", label: "Agent Running" },
  pending: { backgroundColor: "#f8d7da", color: "#842029", label: "Analyzing" },
  planned: { backgroundColor: "#d1e7dd", color: "#0f5132", label: "Planned" },
  code_generated: { backgroundColor: "#cfe2ff", color: "#084298", label: "Generating Agent" },
  csv_done: { backgroundColor: "#cfe2ff", color: "#084298", label: "Generating Report" },
  error: { backgroundColor: "#f8d7da", color: "#842029", label: "Failed" },
  unknown: { backgroundColor: "#e2e3e5", color: "#41464b", label: "Unknown" },
};

const AGENT_STATUS_LABEL_KEY: Record<keyof typeof AGENT_STATUS_COLOR, keyof AgentStatusLabels> = {
  ready: "Ready",
  generating: "Agent Running",
  pending: "Analyzing",
  planned: "Planned",
  code_generated: "Generating Agent",
  csv_done: "Generating Report",
  error: "Failed",
  unknown: "Unknown",
};

type AgentStatusLabels = {
  Ready: string;
  "Agent Running": string;
  Analyzing: string;
  Planned: string;
  "Generating Agent": string;
  "Generating Report": string;
  Failed: string;
  Unknown: string;
};

export const AgentStatusBadge = ({ status }: { status: string }) => {
  const { t } = useTranslation(["tclip"]);
  const key = status as keyof typeof AGENT_STATUS_COLOR;
  const labelKey = AGENT_STATUS_LABEL_KEY[key];
  return (
    <Badge
      pill
      className={css({
        marginLeft: "1rem",
        marginTop: "1.25rem",
        padding: "0.5rem 1rem",
        fontSize: "medium",
      })}
      style={{
        color: AGENT_STATUS_COLOR[key].color,
        backgroundColor: AGENT_STATUS_COLOR[key].backgroundColor,
      }}
      bg="custom"
    >
      {t(($) => $.tclip.agentStatus[labelKey])}
    </Badge>
  );
};

export const StartAgent = async (
  name: string,
  promptText: string,
  marketplace: string,
  taskId: string | null,
  is_playground: boolean,
  modify_only: boolean,
) => {
  const data: {
    name: string;
    prompt: string;
    task_id: string | null;
    market_place: string;
    is_playground: string;
    modify_only?: string;
  } = {
    name: name,
    prompt: promptText,
    task_id: taskId,
    market_place: marketplace,
    is_playground: is_playground ? "true" : "false",
    modify_only: modify_only ? "true" : "false",
  };
  return await api.post("/clio/tasks/definitions/set/", data);
};
